import apiRequest from '../apis/api-request';
import { userStore } from '../store/userStore';

const accessToken = userStore.getState().user.token
const sessionService = {

    venueList: async (user) => {
        return apiRequest({
            method:"GET",
            url: "/venue/list",
            data: user,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    // sessionList: async (Data) => {
    //     return apiRequest({
    //         method:"GET",
    //         url: "/session/list",
    //         data: Data,
    //         headers: {
    //             Authorization: "Bearer " + accessToken,
    //         }
    //     });
    // },
    sessionList: async ({ page, size,search,date,venueId,status,speakerId}) => {
        return apiRequest({
          method: "GET",
          url: `/session/list?page=${page}&size=${size}&search=${search}&venueId=${venueId}&date=${date}&status=${status}&speakerId=${speakerId}`,  
          headers: {
            Authorization: "Bearer " + accessToken,
          }
        });
      },

    sessionCreate: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/session/create",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessionUpdate: async (Data) => {
        return apiRequest({
            method:"PUT",
            url: "/session/edit/"+Data.id,
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessionView: async (id) => {
        return apiRequest({
            method:"GET",
            url: "/session/view/"+id,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },




    sessionSpeaker: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/speaker/session",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    venueCreate: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/venue/create",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },


    venueUpdate: async (Data) => {
        return apiRequest({
            method:"PUT",
            url: "/venue/edit/"+Data.id,
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    speakerList: async (Data) => {
        return apiRequest({
            method:"GET",
            url: "/user/speaker/list",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessionPublish: async (id) => {
        return apiRequest({
            method:"PUT",
            url: "/session/publishsession/"+id,
            
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    categoryList: async (user) => {
        return apiRequest({
            method:"GET",
            url: "/session/list-category",
            data: user,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessionModerators: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/session/moderators",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessionDelete: async (id) => {
        return apiRequest({
            method:"DELETE",
            url: "/session/delete/" + id,
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
      },

      sessioncategoryList: async () => {
        return apiRequest({
          method: "GET",
          url: `/category/list`,  
          headers: {
            Authorization: "Bearer " + accessToken,
          }
        });
      },

    sessioncategoryCreate: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/category/create",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    sessioncategoryUpdate: async (Data) => {
        return apiRequest({
            method:"PUT",
            url: "/category/edit/"+Data.id,
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        });
    },

    categoryList: async (user) => {
        return apiRequest({
            method:"GET",
            url: "/session/list-category",
            data: user,
           
        });
    },

    venueListsite: async (user) => {
        return apiRequest({
            method:"GET",
            url: "/venue/list-venue",
            data: user,
            
        });
    },

    sessioncategoryDelete: async (id) => {
        return apiRequest({
            method:"DELETE",
            url: "/category/delete/" + id,
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
      },
      addsponsors: async (Data) => {
        return apiRequest({
            method:"POST",
            url: "/session/sponsors/",
            data: Data,
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
      },
      logolist: async (id) => {
        return apiRequest({
            method:"GET",
            url: "/session/listlogo/",
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
      },

speakerConnect: async (id) => {
        return apiRequest({
            method:"POST",
            url: "/session/speakerconnect/" + id,
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
      },


    
}


export default sessionService;
